import { useState } from "react";
import { useHistory } from "react-router-dom";
import axiosInstance from "config/axiosInstance";
import { clearUserSession } from "utils/auth";
import { useAppAlert } from "hooks/useAppAlert";
import Card from "@mui/material/Card";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { showAlert, AlertBanner } = useAppAlert();

  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      showAlert("Por favor completa todos los campos", "warning");
      return;
    }

    if (newPassword !== confirmPassword) {
      showAlert("Las contraseñas nuevas no coinciden", "warning");
      return;
    }

    if (newPassword.length < 8) {
      showAlert("La nueva contraseña debe tener al menos 8 caracteres", "warning");
      return;
    }

    if (!/[a-zA-Z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
      showAlert("La contraseña debe incluir al menos una letra y un número", "warning");
      return;
    }

    setLoading(true);
    try {
      const res = await axiosInstance.post("/auth/change-password", {
        currentPassword,
        newPassword,
      });

      if (res.data.success) {
        showAlert(
          "Contraseña cambiada. Por seguridad debes iniciar sesión de nuevo. Se envió confirmación a tu correo.",
          "success"
        );
        clearUserSession();
        setTimeout(() => {
          history.push("/authentication/sign-in");
        }, 1500);
      } else {
        showAlert(res.data.message || "Error al cambiar la contraseña", "error");
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Error al cambiar la contraseña";
      showAlert(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <VuiBox p={3}>
        <AlertBanner />
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb={2}>
          Cambiar Contraseña
        </VuiTypography>

        <VuiBox mb={2}>
          <VuiTypography variant="button" color="text" fontWeight="medium" mb={1}>
            Contraseña Actual
          </VuiTypography>
          <VuiInput
            type="password"
            placeholder="Contraseña actual"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            sx={{ width: "100%" }}
          />
        </VuiBox>

        <VuiBox mb={2}>
          <VuiTypography variant="button" color="text" fontWeight="medium" mb={1}>
            Nueva Contraseña
          </VuiTypography>
          <VuiInput
            type="password"
            placeholder="Nueva contraseña"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ width: "100%" }}
          />
        </VuiBox>

        <VuiBox mb={2}>
          <VuiTypography variant="button" color="text" fontWeight="medium" mb={1}>
            Confirmar Nueva Contraseña
          </VuiTypography>
          <VuiInput
            type="password"
            placeholder="Confirmar nueva contraseña"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ width: "100%" }}
          />
        </VuiBox>

        <VuiButton color="info" fullWidth onClick={handleChangePassword} disabled={loading}>
          {loading ? "Cambiando..." : "Cambiar Contraseña"}
        </VuiButton>
      </VuiBox>
    </Card>
  );
}

export default ChangePassword;
